import React from 'react';
import { Row, Col, Card, CardBody, CardTitle, CardText, Label } from 'reactstrap';
import CheckBox from '../../../componentes/checkbox/checkbox.component';
import './vincular-cancelado.styles.css';
import IntlMessage from "../../../helpers/intlMessage";

const VincularCanceladoPage = (props) => (
    <div className="vincular-exame-container">
        <p className="title"><IntlMessage id="dashboards.examDetails.linkExams" /></p>
        <Row>
            {
                props.exames.length > 0 && <div style={{ height: `${props.altura - 38}px`, width: '100%', overflowY: 'scroll', overflowX: 'hidden' }}>
                    <Col>
                        {
                            props.exames.map(item => {
                                return (<Row key={item.id}>
                                    <Col>
                                        <Card className={item.vinculado ? "vinculado" : undefined}>
                                            <Row>
                                                <Col sm="1" style={{ paddingRight: '0px' }}>
                                                    <CardBody className="icon">
                                                        <i className="fas fa-notes-medical"></i>
                                                    </CardBody>
                                                </Col>
                                                <Col style={{ padding: '0px', maxWidth: '75%' }}>
                                                    <CardBody style={{ paddingLeft: '0px' }}>
                                                        <CardTitle>
                                                            {`${item.nrExame} - ${item.exame}`}
                                                            <div style={{ float: 'left', display: 'contents' }}>
                                                                <Label><div className="exame-aberto"> <IntlMessage id="dashboards.examDetails.canceled" /></div></Label>
                                                            </div>
                                                        </CardTitle>
                                                        <CardText>{item.laudo}</CardText>
                                                        <CardText>{item.data}</CardText>
                                                    </CardBody>
                                                </Col>
                                                <Col sm="1" style={{ paddingRight: '65px' }}>
                                                    <CardBody className="icon">
                                                        <CheckBox
                                                            onChange={(e) => { props.vincularExame(e.target.checked, item.laudo) }}
                                                            checked={item.vinculado}
                                                            disabled={props.exameEntregue}
                                                        />
                                                    </CardBody>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>)
                            })
                        }
                    </Col>
                </div>
            }
        </Row>
    </div>
)

export default VincularCanceladoPage;


// WEBPACK FOOTER //
// ./src/app/common/vincularCancelado/vincular-cancelado.page.js